// extracted by mini-css-extract-plugin
export default {"content":"CreateNewLightboxDialog_content__u4P4S"};